// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__r6L5k","firstChild":"Modal_firstChild__Tah+h"};